module.exports = __webpack_public_path__ + "static/media/relogio-prazo-expirado.8fda8249.png";